// extracted by mini-css-extract-plugin
export var container = "_17-0";
export var disabled = "_17-4";
export var fullWidth = "_17-3";
export var lined = "_17-1";
export var selected = "_17-5";
export var tab = "_17-2";